import React from "react";
import PropTypes from "prop-types";
import getStyled from "../../hooks/getStyled";
import { getRGBColorByHex } from "../../services/colorsService";

const { styled } = getStyled();

const StyledWrapper = styled("div", { shouldForwardProp: false })(
  ({ theme, dimension, variant, ignoreicon }) => ({
    backgroundColor:
      theme.components.haloIcon[variant]?.backgroundColor ??
      getRGBColorByHex(theme.palette.grey225.main, 0.2),
    width: `${dimension}px`,
    minWidth: `${dimension}px`,
    height: `${dimension}px`,
    minHeight: `${dimension}px`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "100%",
    ".MuiSvgIcon-root": {
      ...(variant &&
        !ignoreicon && {
        color: theme.components.haloIcon[variant]?.color ?? "none",
      }),
    },
  })
);

const SFHaloIconWrapper = ({
  size = "medium",
  variant,
  children,
  ignoreIcon = false,
}) => {
  let dimension;

  switch (size) {
  case "hierarchy":
    dimension = 28;
    break;
  case "small":
    dimension = 32;
    break;
  case "medium":
    dimension = 50;
    break;
  case "large":
    dimension = 70;
    break;
  default:
    dimension = size;
  }

  return (
    <StyledWrapper
      className={"SFHaloIconWrapper-root"}
      dimension={dimension}
      variant={variant}
      ignoreicon={ignoreIcon}
    >
      {children}
    </StyledWrapper>
  );
};

SFHaloIconWrapper.propTypes = {
  /* The icon to be wrapped with halo */
  children: PropTypes.node.isRequired,
  /* The halo size. Default is medium */
  size: PropTypes.oneOfType([
    PropTypes.oneOf(["small", "medium", "large", "hierarchy"]),
    PropTypes.number,
  ]),
  /* The halo color*/
  backgroundColor: PropTypes.string,
};

export default SFHaloIconWrapper;
